
// Local storage keys for persistence
export const STAT_CARDS_STORAGE_KEY = 'dashboard-stat-cards';
export const STATS_GRID_TITLE_KEY = 'dashboard-stats-grid-title';

// Default values
export const DEFAULT_GRID_TITLE = 'Stats';
